import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const RRULE_MAP = {
  'daily': 'RRULE:FREQ=DAILY',
  'weekly': 'RRULE:FREQ=WEEKLY',
  'monthly': 'RRULE:FREQ=MONTHLY',
  'yearly': 'RRULE:FREQ=YEARLY',
};

export function recurrenceToRRule(type) {
  if (!type || type === 'none') return null;
  return RRULE_MAP[type] || type;
}

export function rruleToRecurrence(rrule) {
  if (!rrule || rrule === 'none') return 'none';
  for (const [type, rule] of Object.entries(RRULE_MAP)) {
    if (rule === rrule) return type;
  }
  return rrule;
}
